module.exports = __webpack_public_path__ + "static/media/bridge.8a90021b.svg";